<template>
  <div class='maxmin'>
        <span class='mr15' v-for='item in valueArray' :key='item.id'>
            {{ item.text }}
            <span v-if='listObj[item.currentValue] !== undefined && unitObj.unit'>
                {{ (TempUtils.convertToCelsius(Number(listObj[item.currentValue]), unitObj.unit)).toFixed(2)
              }}{{ unitObj.unit }}
            </span>
            <span v-else> -- </span>
        </span>
  </div>
</template>

<script>
import { TempUtils } from '@/utils/TempUtil.js'

export default {
  props: ['listObj', 'unitObj'],
  data () {
    return {
      TempUtils, // 1. 修复模板报错：挂载到 data
      valueArray: [] // 2. 修复 $t 报错：初始化为空数组
    }
  },
  created () {
    // 3. 修复 $t 报错：在生命周期里初始化需要翻译的文本
    this.valueArray = [
      {
        id: 2,
        text: this.$t('integration.maximum') + ':',
        currentValue: 'maxVal'
      },
      {
        id: 3,
        text: this.$t('integration.minimum_value') + ':',
        currentValue: 'minVal'
      },
      {
        id: 4,
        text: this.$t('integration.average_value') + ':',
        currentValue: 'avgVal'
      }
    ]
  },
  computed: {
    currentValue () {
      let Obj = this.$route.query['probe_value'] ? JSON.parse(this.$route.query['probe_value']) : {}
      return Obj[this.unitObj.key] && Obj[this.unitObj.key].val + this.unitObj.unit
    }
  },
  watch: {
    listObj () {
      console.log('listObj=', this.listObj)
    },
    unitObj () {
      console.log('unitObj=', this.unitObj)
    }
  }
}
</script>

<style lang='scss' scoped>
.maxmin {
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  margin-bottom: 15px;

  .mr15 {
    margin-right: 15px;
  }
}
</style>
